import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Button } from 'antd'
import { withTranslation } from 'react-i18next'

@inject('emailTemplateStore')
@observer
class ViewModal extends Component {
  state = {
  }
  formRef = React.createRef()
  componentDidMount() {
  }
  render() {
    const { emailTemplateStore, addModalVisible, handleCancel, t } = this.props
    const { detailsObj } = emailTemplateStore
    return (
      <>
        <Modal
          title={
            <>
              <div>邮件模板预览</div>
              <div style={{marginTop: 10, fontSize: 16 }}>主题：{detailsObj?.name}</div>
            </>
          }
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width={'80%'}
          centered
          footer={<Button key="Cancel" onClick={handleCancel}>{t(`general.close`)}</Button>}
        >
          <div dangerouslySetInnerHTML={{ __html: detailsObj?.content }} />
        </Modal>
      </>
    )
  }
}

export default withTranslation()(ViewModal)
